<!-- Start Content-->
<div class="container-fluid">
  <div class="row my-1 userTables">
    <div class="col-md-12">
        <h2>SPORT SETTING OF {{data?.user?.username}}</h2>
        <div class="admin_form">
          <div class="row justify-content-center">
            <div class="col-md-6">
              <div class="row checkboxui">
                <div class="col-md-3 col-4" *ngFor="let item of data?.sports;let i=index;">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" (change)="item.isChecked = !item?.isChecked" [checked]="item?.isChecked" id="gridCheck{{i}}">
                    <label class="form-check-label" for="gridCheck{{i}}">
                      <span>{{item?.name}}:</span>
                    </label>
                  </div>
                </div>
                <div class="col-12">
                  <button type="submit" (click)="onSubmit()" class="btn btnSubmit">SAVE</button>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</div>